//Globals
import 'resources/css/global.css';
import 'setimmediate';

import { initSentry, logSentryError, SentryContext } from 'utils/loggingUtil';
import { initProxy } from "bootstrap/officeDialogProxy";
import { Utilities } from "utils/appUtil";
import { initOfficeMock } from 'mock/officeMock';
import { Environment } from "bootstrap/environment";
import { ViewMode, YasoonSetting } from "utils/enums";
import { WindowUtil } from 'utils/windowUtil';
import { getUrlParameterByName } from '@yasoonofficial/runtime';
import { getGlobalOfficeSetting } from 'office/officeStorageService';
import { GlobalError } from 'globalError';

initSentry();

const officeInitFct = async (reason) => {
    console.log('[Bootstrap] Office initialization started, reason:', reason);
    try {
        //Some Safaris seems to not have a proper Intl API...
        //See Sentry: JIRA-FOR-OUTLOOK-6A
        console.log('[Bootstrap] Polyfilling Intl...');
        await Utilities.polyfillIntl();

        //Init our special Proxy, so the Office API is available inside the dialog
        if (Environment.needsOfficeProxy()) {
            console.log('[Bootstrap] Initializing Office proxy...');
            await initProxy();
            console.log('[Bootstrap] Office proxy initialized');
        }

        //Older Outlook versions may not have diagnostics?
        let platform = Environment.getPlatform();
        //Add CSS classes for platformtype.
        //Classes are: .isPC, .isMac, .isiOS, .isAndroid, .isOfficeOnline , .isUniversal (for Windows RT - does that exist for Outlook?)
        let body = document.getElementsByTagName('body')[0];
        body.className += ((body.className) ? ' ' : '') + `is${platform}`;

        //detect safari for css
        if (Environment.detectSafari()) {
            console.log('[Bootstrap] Safari detected');
            body.className += ((body.className) ? ' ' : '') + 'isSafari';
        }

        //ViewMode Classes (E.g. for Welcome Screen that is shown everywhere)
        if (Environment.isRunningInDialog()) {
            console.log('[Bootstrap] Running in dialog mode');
            body.className += ((body.className) ? ' ' : '') + 'isDialog';
        } else {
            console.log('[Bootstrap] Running in sidebar mode');
            body.className += ((body.className) ? ' ' : '') + 'isSidebar';
        }

        console.log('[Bootstrap] Loading main.bundle.js...');
        WindowUtil.loadScript('js/main.bundle.js');
        console.log('[Bootstrap] Initialization complete');

    } catch (e) {
        logSentryError(e, SentryContext.global);
        let errorMessage = (e instanceof Error) ? e.message : JSON.stringify(e);
        return GlobalError.print(errorMessage);
    }
};

if (getUrlParameterByName('fromLoader')) {
    officeInitFct(Office.InitializationReason.DocumentOpened);
} else {
    Promise.resolve().then(async () => {
        // Now that the office.js is loaded, make sure we actually call Office.initialize from VSTO
        if (Environment.isWrapperAddin()) {
            window['Office'] = {} as any;
            WindowUtil.loadScript("./js/initWrapper.js");
        }

        Office.initialize = officeInitFct;
    });
}

if (window?.location?.href?.includes('initMock=true')) {
    //let main = document.getElementById('main');
    //main.style.margin = '20px';

    let body = document.getElementsByTagName('body')[0];
    body.className += ((body.className) ? ' ' : '') + `isPC isDialog`;
    setTimeout(() => {
        initOfficeMock();
        Office.initialize(Office.InitializationReason.DocumentOpened);
    }, 1000);
}
